import { render } from "./RelatPerson.vue?vue&type=template&id=2054da0d"
import script from "./RelatPerson.vue?vue&type=script&lang=js"
export * from "./RelatPerson.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__